if (!customElements.get('product-info-compact')) {
  customElements.define(
    'product-info-compact',
    class ProductInfoCompact extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.purchaseTypeSelectors = document.querySelectorAll('.purchase-type-selector > li');
        this.frequencySelectors = document.querySelectorAll('.purchase-type-selector .option-selector__frequency-selector');
        this.productTypeButtons = document.querySelectorAll('.product-form__product-type-button[data-url]');
        this.flavorButtons = document.querySelectorAll('.flavors-list .flavors-list__flavor > .flavor[data-url]');
        this.quantityButtons = document.querySelectorAll('.subscription-quantity li[data-pack]');
        this.quantityButtonsTriggers = document.querySelectorAll('.subscription-quantity__more-quantity--back');
        this.quantityControls = document.querySelectorAll('.subscription-quantity-box-container .quantity-control');
        this.quantityControlTriggers = document.querySelectorAll('.subscription-quantity li.more.more-quantity');
        this.bannerPurchaseTypeSelectors = document.querySelectorAll('#subscription-product-bar li [type="radio"]');
        this.bannerButtons = document.querySelectorAll('#subscription-product-bar .subscription-product-item .Button');
        this.mainFreeCreamerImage = document.querySelector('media-gallery .media-gallery__slider .slider__media-item:first-child');
        this.productGifts = this.querySelectorAll('.product__gifts [data-gift]');
        this.productType = this.dataset.productType;
        this.quantityButtonsVersion = this.dataset.quantityButtonsVersion || 'compact';
        this.cachedResults = {};
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        setTimeout(() => {
          this.setSelectorsAppearance();
          this.setEventListeners();
          this.setSelectorProductTypeSelector();
          this.prefetchProductData();
          /* Temp solution for BF */
          subscriptionOptions.is_deal_of_the_day && this.closest('.product')?.classList.remove('product-onetime')

          if (window.location.hash.includes('#buy-once') || subscriptionOptions.is_flavored_offer || subscriptionOptions.is_deal_of_the_day)
            this.setPurchaseType(this.querySelector('.option-selector-onetime'),)
        }, 300) 

        document.body.classList.toggle('product-autodeliver', subscriptionOptions.currentRCType == 'autodeliver')
        document.body.classList.toggle('product-onetime', !(subscriptionOptions.currentRCType == 'autodeliver'))

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      setEventListeners() {
        this.purchaseTypeSelectors.forEach(selector => selector.addEventListener('click', () => this.setPurchaseType(selector)))
        this.flavorButtons.forEach(button => button.addEventListener('click', (event) => this.setFlavor(button)))
        this.productTypeButtons.forEach(button => button.addEventListener('click', () => this.setProductType(button)))
        this.quantityButtons.forEach(button => button.addEventListener('click', () => this.setQuantity(button)))
        this.quantityButtonsTriggers.forEach(trigger => trigger.addEventListener('click', () => this.disableQuantityControls()))
        this.quantityControls.forEach(button => button.addEventListener('click', () => this.changeQuantityByControlBox(button)))
        this.quantityControlTriggers.forEach(trigger => trigger.addEventListener('click', () => this.enableQuantityControls()))
        this.frequencySelectors.forEach(selector => selector.addEventListener('change', this.setFrequency.bind(this)))
        this.bannerPurchaseTypeSelectors.forEach(selector => selector.addEventListener('change', () => this.setPurchaseType(selector)))
        this.bannerButtons.forEach(button => button.addEventListener('click', () => this.handleBannerButtonAction(button)))
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      handleBannerButtonAction(button) {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const isPopupToggler = button.classList.contains('Button-subscription-popup');

        if (isPopupToggler) {
          document.getElementById('subscription-product-popup')?.openPopup(button);
        } else {
          this.querySelector('.product-form__buttons button[name="add"]')?.click();
        }
      }

      updateQuantityButtonsBadges() {
        const { currentRCType, discount_codes } = window.subscriptionOptions;
        if (!discount_codes) return;

        this.quantityButtons.forEach(button => {
          const buttonPack = +button.dataset.pack;
          const hasDiscountCode = discount_codes[currentRCType]?.find(discount => discount.quantity == buttonPack && discount.code);
          
          button.querySelector('.pack-discount')?.classList.toggle('pack-discount--accent', !!hasDiscountCode)
        })
      }

      async prefetchProductData() {
        if (!this.productTypeButtons?.length) return;
        const mainSectionId = this.dataset.section;
        const productTypeButtons = Array.from(this.productTypeButtons);
        const productFlavorButtons = Array.from(this.flavorButtons);
        const productUrls = new Set([...productTypeButtons, ...productFlavorButtons].map(typeButton => {
          const { url } = typeButton.dataset;

          return !url ? null : url;
        }))
        
        for (const productUrl of productUrls) {
          let html = null;

          try {
            if (this.cachedResults[productUrl]) {
              html = this.cachedResults[productUrl][mainSectionId];
            } else {
              const response = await this.fetchProductData(productUrl, false);
              if (!response.ok) return;
              html = await this.getHtmlResponse(response, productUrl);
              html = html[mainSectionId];
            }
          } catch(error) {
            console.error('Prefetching products error:' + error)
          }
        }
      }

      setSelectorProductTypeSelector() {
        const productTypes = this.querySelector('.product-form__product-types');
        if (!productTypes) return;

        const { selectorType } = productTypes.dataset;
        if (selectorType == 'built-in') return;

        const productSection = this.closest('.product');
        productSection.querySelector('.product__type-selector')?.appendChild(productTypes);
      }

      async setProductType(button) {
        const productSection = this.closest('.product');
        const productTypes = productSection?.querySelector('.product-form__product-types');

        const productUrl = button.getAttribute('data-url');
        const variantTitle = button.getAttribute('data-variant-title') || '';
        const mainSectionId = this.dataset.section;
        const isCurrentProductType = button.getAttribute('data-product-type') === window.subscriptionOptions?.currentProduct?.product?.type;
        
        if (productTypes) {
          const { selectorType } = productTypes.dataset;
          if (selectorType == 'step-selector') {
            productSection.querySelectorAll('.grid__item').forEach((element, index) => {
              element.classList.remove('grid__item--hidden');
              if (index === 0) element.scrollIntoView({block: 'start', behavior: 'smooth'})
            })
          };
        }
        

        const updateButtonPressedState = () => this.productTypeButtons.forEach(typeButton => typeButton.setAttribute('aria-pressed', button == typeButton));

        if (isCurrentProductType) {
          window.subscriptionOptions.option1 = variantTitle || window.subscriptionOptions.option1;
          this.setSelectorsAppearance();
          updateButtonPressedState();

          return;
        }

        let html = null;

        try {
          if (this.cachedResults[productUrl]) {
            html = this.cachedResults[productUrl][mainSectionId];
          } else {
            const response = await this.fetchProductData(productUrl, false);
            if (!response.ok) return;
            html = await this.getHtmlResponse(response, productUrl);
            html = html[mainSectionId];
          }
          
          if (!html) return;

          const previousOption1 = window.subscriptionOptions.option1;

          const subscriptionOptionsObject = this.buildSubscriptionOptionsObject(html, true);
          window.subscriptionOptions = subscriptionOptionsObject;

          const newProduct = subscriptionOptionsObject.currentProduct?.product;
          const hasOption1 = newProduct?.variants?.some(v => this.areVariantOptionsEquivalent(v.option1, previousOption1));
          if (hasOption1) {
            window.subscriptionOptions.option1 = previousOption1;
          }

          const selectors = this.getSelectorsForProduct(false, true);
          this.updateDOMAndMedia(selectors, html, false);
            
          this.setSelectorsAppearance();
          updateButtonPressedState();
          if (typeof StampedFn !== 'undefined') StampedFn?.reloadUGC();
        } catch (error) {
          console.error(error);
        }
      }

      async setFlavor(button) {
        const productUrl = button.getAttribute('data-url');
        const isOfferProduct = this.productType === 'Offer';
        const isTeaProduct = window.subscriptionOptions.template === 'tea';
        
        let mainSectionId = this.dataset.section;
        const coffeeDetailsSectionId = document.querySelector('.coffee-details')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');
        const benefitsSectionId = document.querySelector('.landing-image-benefits__wrapper')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');

        let html = null;
        let detailsHtml = null;
        let benefitsHtml = null;

        this.updateFlavorButtonState(productUrl);
        
        try {
          if (this.cachedResults[productUrl]) {
            html = this.cachedResults[productUrl][mainSectionId];
            if (coffeeDetailsSectionId) detailsHtml = this.cachedResults[productUrl][coffeeDetailsSectionId];
            if (benefitsSectionId && isTeaProduct) benefitsHtml = this.cachedResults[productUrl][benefitsSectionId];
          } else {
            const response = await this.fetchProductData(productUrl, isOfferProduct);
            if (!response.ok) return;
            html = await this.getHtmlResponse(response, productUrl);
            html = html[mainSectionId];
            if (coffeeDetailsSectionId) detailsHtml = this.cachedResults[productUrl][coffeeDetailsSectionId];
            if (benefitsSectionId && isTeaProduct) benefitsHtml = this.cachedResults[productUrl][benefitsSectionId];
          }
          
          if (!html) return;

          const previousOption1 = window.subscriptionOptions.option1;

          const subscriptionOptionsObject = this.buildSubscriptionOptionsObject(html);
          window.subscriptionOptions = subscriptionOptionsObject;

          const newProduct = subscriptionOptionsObject.currentProduct?.product;
          const hasOption1 = newProduct?.variants?.some(v => this.areVariantOptionsEquivalent(v.option1, previousOption1));
          if (hasOption1) {
            window.subscriptionOptions.option1 = previousOption1;
          }

          const selectors = this.getSelectorsForProduct(isOfferProduct);
          if (!isOfferProduct && isTeaProduct) selectors.push('.accordion__content .metafield-rich_text_field');
          this.updateDOMAndMedia(selectors, html, isOfferProduct);
            
          this.setSelectorsAppearance();
          if (typeof StampedFn !== 'undefined') StampedFn?.reloadUGC();
          if (coffeeDetailsSectionId) this.updateCoffeeDetails(detailsHtml, coffeeDetailsSectionId);
          if (benefitsSectionId && isTeaProduct) this.updateBenefitsSection(benefitsHtml, benefitsSectionId);
        } catch (error) {
          console.error(error);
        }
      }
    
      async fetchProductData(productUrl, isOfferProduct) {
        let mainSectionId = this.dataset.section;

        const coffeeDetailsSectionId = document.querySelector('.coffee-details')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');
        const benefitsSectionId = document.querySelector('.landing-image-benefits__wrapper')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');
        
        let sectionIds = coffeeDetailsSectionId ? `${mainSectionId},${coffeeDetailsSectionId}` : mainSectionId;
        if (benefitsSectionId && window.subscriptionOptions.template === 'tea') sectionIds += `,${benefitsSectionId}`;

        const viewParam = isOfferProduct ?
          '&view=subscription-creamer-offer' :
            this.dataset.templateSuffix ?
              `&view=${this.dataset.templateSuffix}` :
              ''

        const response = await fetch(`${productUrl}?sections=${sectionIds}${viewParam}`);

        return response;
      }
      
      updateFlavorButtonState(productUrl) {
        this.flavorButtons.forEach(button => {
          const buttonUrl = button.dataset.url
          button.parentElement?.classList.toggle('flavors-list__flavor--active', productUrl === buttonUrl);
        });
      }
      
      async getHtmlResponse(response, productUrl) {
        const responseObject = await response.json();
        for (const key in responseObject) {
          responseObject[key] = new DOMParser().parseFromString(responseObject[key], 'text/html');
        }
        this.cachedResults[productUrl] = responseObject; 
        return responseObject;
      }
      
      buildSubscriptionOptionsObject(html, isProductTypeSelector = false) {
        const subscriptionOptionsObject = JSON.parse(html.getElementById('subscription-options-object-json')?.innerText);
        const subscriptionOptionsObjectKeys = !isProductTypeSelector ? 
          ['pack', 'pack_autodeliver', 'pack_onetime', 'shipping_interval_frequency', 'currentRCType', 'qty_style'] :
          [];
      
        subscriptionOptionsObjectKeys.forEach(key => {
          subscriptionOptionsObject[key] = subscriptionOptions[key];
        });
      
        return subscriptionOptionsObject;
      }
      
      getSelectorsForProduct(isOfferProduct, isProductTypeSelector = false) {
        if (isProductTypeSelector) return ['.product-info--mobile .product__title', '.product-info--mobile .product-review-badge', '.product-info .product__title', '.product__flavors', '.purchase-type-selector', '.product-info .product-review-badge', '.product__description', '.subscription-quantity', '.product__features', 'media-gallery', 'product-modal', 'quick-buy-banner .thumbnail', 'quick-buy-banner .title', 'quick-buy-banner .product-review-badge', 'quick-buy-banner .Button-autodeliver.Button-subscription-popup .button__text', 'quick-buy-banner .Button-onetime .button__text', '.subscription-product-preview', '.coffee-details__grid', 'rivo-favorite-button'];

        return isOfferProduct 
          ? ['.product-offer-subtitle', '.product-info--mobile .product-review-badge', '.product-info .product-review-badge', '.product__description', 'media-gallery', 'product-modal', 'rivo-favorite-button'] 
          : ['.product-info--mobile .product__title', '.product-info--mobile .product-review-badge', '.product-info .product__title', '.product-info .product-review-badge', '.product__description', '.product__features', 'media-gallery', 'product-modal', 'quick-buy-banner .thumbnail', 'quick-buy-banner .title', 'quick-buy-banner .product-review-badge', 'quick-buy-banner .Button-autodeliver.Button-subscription-popup .button__text', 'quick-buy-banner .Button-onetime .button__text', '.subscription-product-preview', '.coffee-details__grid', 'rivo-favorite-button'];
      }
      
      updateDOMAndMedia(selectors, html, isOfferProduct) {
        (this.closest('.product__section') || this).querySelectorAll('variant-selects').forEach(picker => {
          const sourcePicker = html.getElementById(picker.id);
          if (sourcePicker) picker.dataset.url = sourcePicker.dataset.url;
        });

        selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          const duplicatedElement = sourceElement?.cloneNode(true)
            
          if (selector === 'rivo-favorite-button' && targetElement) {
            const productFavorites = window.RivoProfileAlpine.store('rivo_favorite_products') || [];
            const translations = window.RivoProfileAlpine.store('rivo_aw_translation') || {};
            const isFavorite = productFavorites.some(function (product) {
              return product && String(product.remote_id) === String(duplicatedElement.dataset.productId);
            });

            targetElement.dataset.productId = duplicatedElement.dataset.productId;
            targetElement.classList.toggle('rivo-favorite-active', isFavorite);
            targetElement.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
            targetElement.setAttribute('aria-label', isFavorite
              ? (translations.favorite_button_active_text || 'Added to favorites')
              : (translations.favorite_button_inactive_text || 'Add to favorites'));

            return;
          }

          if (targetElement && sourceElement && duplicatedElement) {
            targetElement.replaceWith(duplicatedElement);
          }
      
          if (['media-gallery', 'product-modal'].includes(selector)) {
            this.updateMediaGalleryOrModal(duplicatedElement, isOfferProduct, selector);
            if (typeof enableMagnifyZoom === 'function') enableMagnifyZoom();
          }

          if (['.product__flavors'].includes(selector)) {
            this.flavorButtons = document.querySelectorAll('.flavors-list .flavors-list__flavor > .flavor[data-url]');
            this.flavorButtons.forEach(button => button.addEventListener('click', (event) => this.setFlavor(button)));
          }

          if (['.subscription-quantity', '.purchase-type-selector'].includes(selector)) {
            this.quantityButtons = document.querySelectorAll('.subscription-quantity li[data-pack]');
            this.purchaseTypeSelectors = document.querySelectorAll('.purchase-type-selector > li');
            this.frequencySelectors = document.querySelectorAll('.purchase-type-selector .option-selector__frequency-selector');

            this.quantityButtons.forEach(button => button.addEventListener('click', () => this.setQuantity(button)));
            this.purchaseTypeSelectors.forEach(selector => selector.addEventListener('click', () => this.setPurchaseType(selector)));
            this.frequencySelectors.forEach(selector => selector.addEventListener('change', this.setFrequency.bind(this)));
          }
        });

      }
      
      async updateMediaGalleryOrModal(sourceElement, isOfferProduct, selector) {
        const mediaGallerySwiperWrapper = sourceElement?.querySelector('.swiper-wrapper');
        const swipers = sourceElement?.querySelectorAll('[data-swiper]');
          
        if (mediaGallerySwiperWrapper && isOfferProduct && selector == 'media-gallery') {
          mediaGallerySwiperWrapper.insertBefore(this.mainFreeCreamerImage, mediaGallerySwiperWrapper.firstChild);
        }

        await window.loadSwiperAssets();
  
        swipers.forEach(swiper => {
          const options = swiper.dataset.swiper ? JSON.parse(swiper.dataset.swiper) : {};
          const mediaGallerySlider = new Swiper(swiper, options);
          mediaGallerySlider.slideTo(isOfferProduct ? 1 : 0);
        });
      }

      updateCoffeeDetails(html, sectionId) {
        if (!html || !sectionId) return;

        const targetElement = document.querySelector(`#shopify-section-${sectionId} .coffee-details`);
        const sourceElement = html.querySelector('.coffee-details');
        const duplicatedElement = sourceElement?.cloneNode(true)
          
        if (targetElement && sourceElement && duplicatedElement) {
          targetElement.replaceWith(duplicatedElement);
        }
      }

      updateBenefitsSection(html, sectionId) {
        if (!html || !sectionId) return;

        const targetElement = document.querySelector(`#shopify-section-${sectionId} .landing-image-benefits__container`);
        const sourceElement = html.querySelector('.landing-image-benefits__container');
        const duplicatedElement = sourceElement?.cloneNode(true)
          
        if (targetElement && sourceElement && duplicatedElement) {
          targetElement.replaceWith(duplicatedElement);
        }
      }
    
      updateDiscountCode(quantity) {
        const { discount_codes, currentRCType } = window.subscriptionOptions;
        if (!discount_codes) return;

        const currentDiscount = discount_codes[currentRCType]?.find((discount) => {
          return discount.quantity == quantity && discount.code;
        })

        window.subscriptionOptions.discount_codes.current_code = currentDiscount ? currentDiscount.code : null;
      }

      setQuantity(button) {
        const quantity = button.dataset.pack;

        this.quantityButtons.forEach(element => {
          element.classList.remove('active')
          if (element.dataset.pack == quantity) element.classList.add('active')
        })
        
        subscriptionOptions.pack = +quantity;
        subscriptionOptions.pack_autodeliver = +quantity;
        subscriptionOptions.pack_onetime = +quantity;

        this.setSelectorsAppearance();
      }
      
      setFrequency(event) {
        const frequency = +event?.target?.value;
        if (!frequency && isFinite(frequency)) return;
       
        subscriptionOptions.shipping_interval_frequency = frequency;

        this.setSelectorsAppearance();
        document.dispatchEvent(new CustomEvent('product:frequency:change'));
      }

      setPurchaseType(selector, withoutLastFunction = false) {
        let purchaseType = selector.dataset.purchaseType;
        let isAutodeliver = purchaseType == 'autodeliver';
        
        this.purchaseTypeSelectors.forEach(element => element.classList.remove('active'))
        document.querySelectorAll(`.purchase-type-selector > li[data-purchase-type=${purchaseType}]`)?.forEach(selector => selector.classList.add('active'));
       
        if (isAutodeliver) {
          subscriptionOptions.currentRCType = 'autodeliver'
          this.querySelectorAll('[name="selling_plan"]').forEach(input => {
            input.removeAttribute('disabled')
          })
        } else {
          subscriptionOptions.currentRCType = 'onetime'
          this.querySelectorAll('[name="selling_plan"]').forEach(input => {
            input.setAttribute("disabled", '')
          })
        }

        if (document.querySelector('#subscription-product-bar') != null) {
          document.querySelector('#subscription-product-bar .Button-autodeliver').classList.add('hide');
          document.querySelector('#subscription-product-bar .Button-onetime').classList.add('hide');
          document.querySelector('#subscription-product-bar .Button-'+subscriptionOptions.currentRCType).classList.remove('hide');
          document.querySelector('#subscription-product-bar li [type="radio"][value="'+subscriptionOptions.currentRCType+'"]').checked = true;
        }

        document.body.classList.toggle('product-autodeliver', isAutodeliver)
        document.body.classList.toggle('product-onetime', !isAutodeliver)

        document.querySelectorAll('[data-benefits] > div[data-purchase-type]').forEach(benefitBlock => {
          const benefitPurchaseType = benefitBlock.dataset.purchaseType;
          benefitBlock.classList.toggle('hidden', benefitPurchaseType !== subscriptionOptions.currentRCType);
        })

        if (!withoutLastFunction) this.setSelectorsAppearance();
      }

      setSelectorsAppearance() {
        this.getSubscribeVariants();
        document.querySelector('quick-buy-banner')?.setAvailability(
          !subscriptionOptions?.currentVariant?.available || !!subscriptionOptions?.is_sold_out
        );
        this.setVariantOptionsAvailability();
        this.quantityButtonsVersion == 'compact' ? this.setQuantityButtonsCompact() : this.setQuantityButtonsDefault();
        this.setPrices();

        if (this.closest('.section__featured-product')) {
          this.setGiftsAvailability();
          if (window.subscriptionOptions?.discount_codes) {
            this.updateDiscountCode(window.subscriptionOptions.pack);
            if (this.quantityButtonsVersion !== 'compact') this.updateQuantityButtonsBadges();
          };
        }

        let isControlsCurrentQty = subscriptionOptions.qty_style == 2
        if (subscriptionOptions.currentRCType == 'onetime' && subscriptionOptions.is_flavored_offer == true) isControlsCurrentQty = false
        
        document.querySelectorAll('.subscription-quantity li').forEach(button => button.classList.toggle('quantity-box-enabled', isControlsCurrentQty))

        document.querySelectorAll('.subscription-arrow-quantity-box').forEach(function (qtyBox){
          qtyBox.classList.toggle('hidden', !isControlsCurrentQty);
        });

        const atcButton = this.querySelector('.product-form__buttons button[name="add"]') || 
              this.querySelector('.product-bundle-form button.product-steps__add-to-cart');
        const atcButtonText = atcButton?.querySelector('span') || 
              (atcButton?.classList.contains('product-steps__add-to-cart') ? atcButton : null);
        const isATCUnavailable = !subscriptionOptions?.currentVariant?.available || subscriptionOptions?.is_sold_out;
        const isDirectCheckoutButton = atcButton?.closest('product-form')?.getAttribute('data-is-go-checkout') || false;

        if (atcButtonText) {
          const isSpecialOffer = window.location.href.includes('limited-release-3-pack-celebration-edition') || 
               window.location.href.includes('subscribe-today-and-enjoy-your-first-creamer-for-free');
          const buttonText = isATCUnavailable 
            ? window.variantStrings.soldOut 
            : isSpecialOffer 
              ? atcButtonText.textContent 
              : (subscriptionOptions.currentRCType === 'autodeliver' 
          ? document.body.classList.contains('product--atc-text-changed') ? window.variantStrings.addToCartSubscriptionTest : window.variantStrings.addToCartSubscription //Remove after A/B test is over (Restore to one value without condtion)
          : document.body.classList.contains('product--atc-text-changed') ? window.variantStrings.addToCartOnetimeTest : window.variantStrings.addToCartOnetime); //Remove after A/B test is over (Restore to one value without condtion)

          atcButtonText.innerHTML = buttonText;
          if (isDirectCheckoutButton) atcButtonText.innerHTML = isATCUnavailable ? window.variantStrings.soldOut : window.variantStrings.checkout;
          atcButton.disabled = isATCUnavailable;
          atcButton.classList.toggle('product-form__submit--out-of-stock', isATCUnavailable);

          if (window.subscriptionOptions?.currentProduct?.product?.type == 'GiftCard') atcButtonText.innerHTML = isATCUnavailable ? window.variantStrings.soldOut : window.variantStrings.addToCart;
        }
      }

      areVariantOptionsEquivalent(first, second) {
        if (first === second) return true;
        const groundOptions = ['Freshly Ground', 'Fine Grind'];
        return groundOptions.includes(first) && groundOptions.includes(second);
      }

      setVariantOptionsAvailability() {
        const { currentProduct, currentVariant, is_sold_out } = window.subscriptionOptions;
        const variants = currentProduct?.product?.variants;
        if (!variants) return;

        (this.closest('.product__section') || this).querySelectorAll('variant-selects').forEach(picker => {
          const optionValues = Array.from(picker.querySelectorAll('select, fieldset'), option =>
            Array.from(option.querySelectorAll('input[type="radio"], option'), input => input.value)
          );
          const pickerVariants = variants.map(variant => {
            const options = variant.options.map((value, index) =>
              optionValues[index]?.find(option => this.areVariantOptionsEquivalent(option, value)) || value
            );
            if (options.every((value, index) => value === variant.options[index])) return variant;
            return { ...variant, options, title: options.join(' / ') };
          });
          picker.variantData = pickerVariants;
          const variantJson = picker.querySelector('[type="application/json"]');
          if (variantJson) variantJson.textContent = JSON.stringify(pickerVariants);

          picker.querySelectorAll('.product-form__input').forEach((option, index) => {
            const availableValues = pickerVariants
              .filter(variant => variant.available && !is_sold_out &&
                Array.from({ length: index }, (_, previousIndex) => previousIndex + 1)
                  .every(position => variant[`option${position}`] === currentVariant?.[`option${position}`]))
              .map(variant => variant.options[index]);

            picker.setInputAvailability(
              [...option.querySelectorAll('input[type="radio"], option')],
              availableValues
            );
          });
        });
      }

      enableQuantityControls() {
        subscriptionOptions.qty_style = 2;
        this.toggleQuantityBackVisibility(true)
        this.setSelectorsAppearance();
      }

      disableQuantityControls() {
        subscriptionOptions.qty_style = 1;
        this.toggleQuantityBackVisibility(false)
        this.setSelectorsAppearance();

        this.quantityButtons.forEach(button => {
          if (button.classList.contains('active')) button.click();
        })
      }

      toggleQuantityBackVisibility(isShown) {
        this.quantityButtonsTriggers.forEach(trigger => {
          trigger.style.display = isShown ? 'flex' : 'none'
        })
      }

      changeQuantityByControlBox(controlButton) {
        let type = controlButton.getAttribute('data-quantity-type');
        let pack = subscriptionOptions.pack;
        if (type == 'plus') {
          if (subscriptionOptions.product_name == 'Spring Special' && subscriptionOptions.pack >= 4) {
            return
          }
          pack ++;
        } else if (pack >= 2) {
          pack --;
          if (subscriptionOptions.template == 'pod') {
            if (pack == 1 && subscriptionOptions.unit_step == 12) {
              pack = 2;
            }
          }
        }
        const quantity = Math.ceil(pack);

        subscriptionOptions.pack = quantity;
        subscriptionOptions.pack_autodeliver = quantity;
        subscriptionOptions.pack_onetime = quantity;
        
        this.setSelectorsAppearance();
      }

      setQuantityButtonsCompact() {
        let nowPack = subscriptionOptions.pack;

        const onetimeSelector = this.querySelector('.option-selector-onetime'),
              autodeliverSelector = this.querySelector('.option-selector-autodeliver');

        if (onetimeSelector && autodeliverSelector) {
          const stickyAutodeliverOption = document.getElementById('subscription-option-selector-popup-autodeliver')?.closest('li') || null;
          autodeliverSelector.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
          if (stickyAutodeliverOption) stickyAutodeliverOption.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
        }

        if (!subscriptionOptions.hasSubscribe) {
          subscriptionOptions.currentRCType = 'onetime';
          nowPack = subscriptionOptions.pack;

          if (onetimeSelector) {
            this.setPurchaseType(onetimeSelector, true);
          }
        }

        let quantityButtons = document.querySelectorAll('.subscription-quantity [data-pack]:not(.more)');
        quantityButtons.forEach(function (button){
          let purchaseType = button.dataset.purchaseType;
          button.classList.add('hidden')
          if (
            subscriptionOptions.currentRCType == 'autodeliver' && purchaseType == 'autodeliver' ||
            subscriptionOptions.currentRCType == 'onetime' && purchaseType == 'onetime' || 
            purchaseType == 'both'
          ) {
            button.classList.remove('hidden')
          }
        });

        if (this.hasAttribute('data-has-sale-badges')) {
          let nowPricePerUnit = 0;
          let percents = subscriptionOptions.onetimePercent;
          if (subscriptionOptions.currentRCType == 'autodeliver') {
            percents = subscriptionOptions.autodeliverPercent;
          }
          
          let percentsLength = percents.length;
          let discountCode = '';
          let discountLabel = '';
          
          if (nowPack > percentsLength) {
            discountLabel = 'SAVE';
            discountCode = percents[percentsLength-1] + '%';
          } else {
            for (var i in percents) {
              if (i == nowPack-1 && percents[i] != 0) {
                discountLabel = 'SAVE';
                discountCode = percents[i] + '%';
              }
            }
          }

          quantityButtons.forEach(function (button){
            button.querySelector('.pack-discount').innerHTML = '';
            let pack = parseInt(button.getAttribute('data-pack'));

            if (window.dynamicPricing?.enabled) {
              const { currentRCType, unit } = subscriptionOptions;

              pack += window.dynamicPricing.totalQuantity?.[currentRCType]?.[unit] ?? 0;
            }
            
            if (pack < percentsLength) {
              pack = pack - 1;
            } else {
              pack = percentsLength - 1;
            }
            if (percents[pack]) {
              button.querySelector('.pack-discount').classList.remove('hide');
            } else {
              button.querySelector('.pack-discount').classList.add('hide');
            }
            button.querySelector('.pack-discount').innerHTML = percents[pack] ? 'SAVE ' + percents[pack] + '%': '';

            let purchase_type = button.dataset.purchaseType;
            button.classList.add('hidden')
            if (
              subscriptionOptions.currentRCType == 'autodeliver' && purchase_type == 'autodeliver' ||
              subscriptionOptions.currentRCType == 'onetime' && purchase_type == 'onetime' || 
              purchase_type == 'both'
            ) {
              button.classList.remove('hidden')
            }
          });

          document.querySelectorAll('.subscription-arrow-quantity-box .quantity-discount-box').forEach(function(discountBox){
          if (discountCode != '' && discountCode != 'undefined%') {
            discountBox.classList.remove('hide');
          } else {
            discountBox.classList.add('hide');
          }
          discountBox.innerHTML = discountLabel+' '+discountCode;
        });

        document.querySelectorAll('.subscription-detail .discount').forEach(discountLabel => {
          discountLabel.innerHTML = 'Save ' + discountCode;
        })

        if (nowPricePerUnit) {
          document.querySelectorAll('.subscription-arrow-quantity-box .price-per-unit').forEach(function(discountBox){
            discountBox.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (nowPricePerUnit / 100));
            if (window.templateSuffix == 'subscription-bundle-new' || window.templateSuffix == 'statick-quantity') {
              let wrapperForBundles = document.querySelector('.price-per-bundle')
              let dividerForPrice = +document.querySelector('.subscription-quantity .pack-icon-name .pack-icon').innerText
              let dividerForBundle = +document.querySelector('.quantity-input-box .quantity-number').innerText
              let bagPrice =  window.theme.moneyFormat.replace('{{amount}}', (nowPricePerUnit / 100 / dividerForPrice));
              let priceForBundles = window.theme.moneyFormat.replace('{{amount}}', ((nowPricePerUnit / dividerForPrice / 100) * dividerForBundle).toFixed(2));
              wrapperForBundles.innerHTML = priceForBundles
              let bagPriceStr = bagPrice.toString()
              let bagPriceArr = Array.from(bagPriceStr.split('.')[1])
              let bagPriceNew = bagPriceStr.split('.')[0] + '.' + bagPriceArr[0] + '' + bagPriceArr[1]
              discountBox.innerHTML = bagPriceNew
            }
          }); 
        }

        document.querySelectorAll('.subscription-arrow-quantity-box .quantity-number').forEach(function(qtyNumber){
          let pack = nowPack;
          if (subscriptionOptions.template == 'pod') {
            if (subscriptionOptions.unit_step == 12) {
              if (pack != 1) {
                pack = (pack - 1) * 2;
              }
            }
          }
          if (subscriptionOptions.product_name == 'Limited Release: Dur Feres. Ethiopia' || subscriptionOptions.product_name == 'Limited Release: Todos Santos. Guatemala' || subscriptionOptions.product_name == 'Mother’s Day Special – 12 Oz' ) {
            qtyNumber.innerHTML = subscriptionOptions.pack
            subscriptionOptions.pack_onetime = subscriptionOptions.pack
          } else if (subscriptionOptions.currentProduct?.product.tags.includes('Product-Sell-Out')) {
            if (subscriptionOptions.template == 'pod') {
              qtyNumber.innerHTML = subscriptionOptions.pack * subscriptionOptions.unit_step
              subscriptionOptions.pack_onetime = subscriptionOptions.pack
            } else {
              qtyNumber.innerHTML = subscriptionOptions.pack
              subscriptionOptions.pack_onetime = subscriptionOptions.pack
            }
          } else {
            qtyNumber.innerHTML = pack*subscriptionOptions.unit_step;
          }
        });
        }
      }

      setQuantityButtonsDefault() {
        let nowPack = subscriptionOptions.pack;

        const onetimeSelector = this.querySelector('.option-selector-onetime'),
          autodeliverSelector = this.querySelector('.option-selector-autodeliver');

        if (onetimeSelector && autodeliverSelector) {
          const stickyAutodeliverOption = document.getElementById('subscription-option-selector-popup-autodeliver')?.closest('li') || null;
          autodeliverSelector.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
          if (stickyAutodeliverOption) stickyAutodeliverOption.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
        }

        if (!subscriptionOptions.hasSubscribe) {
          subscriptionOptions.currentRCType = 'onetime';
          nowPack = subscriptionOptions.pack_onetime;

          if (onetimeSelector) {
            this.setPurchaseType(onetimeSelector, true);
          }
        }

        if (window.dynamicPricing?.enabled) {
          const { currentRCType, unit } = subscriptionOptions;

          nowPack += window.dynamicPricing.totalQuantity?.[currentRCType]?.[unit] ?? 0;
        }

        let nowPricePerUnit = 0;
        let percents = subscriptionOptions.onetimePercent;
        if (subscriptionOptions.currentRCType == 'autodeliver') {
          percents = subscriptionOptions.autodeliverPercent;
        }

        let autodeliverDiscountValueMax = subscriptionOptions.autodeliverPercent[subscriptionOptions.autodeliverPercent.length - 1];

        document.querySelectorAll('.purchase-type-selector .option-selector-autodeliver .discount-label').forEach(function(discountBox){
          discountBox.innerHTML = '<span class="discount-label--percentage">' + autodeliverDiscountValueMax + '</span>%';
        });

        let shippingInfoRow = this.querySelectorAll('.ProductForm_shipping_info-row');
        shippingInfoRow.forEach(function(row){
          row.classList.remove('autodeliver');
          row.classList.remove('onetime');
          row.classList.add(subscriptionOptions.currentRCType);
        });

        let percentsLength = percents.length;
        let  discountCode = '';
        let  discountLabel = '';
        if (nowPack > percentsLength) {
          discountLabel = 'SAVE';
          discountCode = percents[percentsLength-1] + '%';
        } else {
          for (var i in percents) {
            if (i == nowPack-1 && percents[i] != 0) {
              discountLabel = 'SAVE';
              discountCode = percents[i] + '%';
            }
          }
        }
        let quantityButtons = document.querySelectorAll('.subscription-quantity [data-pack]:not(.more)');
        quantityButtons.forEach(function (button){
          button.querySelector('.pack-discount').innerHTML = '';
          let pack = parseInt(button.getAttribute('data-pack'));

          if (window.dynamicPricing?.enabled) {
            const { currentRCType, unit } = subscriptionOptions;

            pack += window.dynamicPricing.totalQuantity?.[currentRCType]?.[unit] ?? 0;
          }
          
          if (pack < percentsLength) {
            pack = pack - 1;
          } else {
            pack = percentsLength - 1;
          }
          if (percents[pack]) {
            button.querySelector('.pack-discount').classList.remove('hide');
          } else {
            button.querySelector('.pack-discount').classList.add('hide');
          }
          button.querySelector('.pack-discount').innerHTML = percents[pack] ? 'SAVE ' + percents[pack] + '%': '';

          let purchase_type = button.dataset.purchaseType;
          button.classList.add('hidden')
          if (
            subscriptionOptions.currentRCType == 'autodeliver' && purchase_type == 'autodeliver' ||
            subscriptionOptions.currentRCType == 'onetime' && purchase_type == 'onetime' || 
            purchase_type == 'both'
          ) {
            button.classList.remove('hidden')
          }
        });

        const currentVolumeDiscounts = subscriptionOptions.currentRCType == 'onetime' ? subscriptionOptions.volume_discounts_onetime : subscriptionOptions.volume_discounts_subs
        setButtonPrices(currentVolumeDiscounts);

        document.querySelectorAll('.subscription-arrow-quantity-box .quantity-discount-box').forEach(function(discountBox){
          if (discountCode != '' && discountCode != 'undefined%') {
            discountBox.classList.remove('hide');
          } else {
            discountBox.classList.add('hide');
          }
          discountBox.innerHTML = discountLabel+' '+discountCode;
        });

        document.querySelectorAll('.subscription-detail .discount').forEach(discountLabel => {
          discountLabel.innerHTML = 'Save ' + discountCode;
        })

        if (nowPricePerUnit) {
          document.querySelectorAll('.subscription-arrow-quantity-box .price-per-unit').forEach(function(discountBox){
            discountBox.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (nowPricePerUnit / 100));
            if (window.templateSuffix == 'subscription-bundle-new' || window.templateSuffix == 'statick-quantity') {
              let wrapperForBundles = document.querySelector('.price-per-bundle')
              let dividerForPrice = +document.querySelector('.subscription-quantity .pack-icon-name .pack-icon').innerText
              let dividerForBundle = +document.querySelector('.quantity-input-box .quantity-number').innerText
              let bagPrice =  window.theme.moneyFormat.replace('{{amount}}', (nowPricePerUnit / 100 / dividerForPrice));
              let priceForBundles = window.theme.moneyFormat.replace('{{amount}}', ((nowPricePerUnit / dividerForPrice / 100) * dividerForBundle).toFixed(2));
              wrapperForBundles.innerHTML = priceForBundles
              let bagPriceStr = bagPrice.toString()
              let bagPriceArr = Array.from(bagPriceStr.split('.')[1])
              let bagPriceNew = bagPriceStr.split('.')[0] + '.' + bagPriceArr[0] + '' + bagPriceArr[1]
              discountBox.innerHTML = bagPriceNew
            }
          }); 
        }

        document.querySelectorAll('.subscription-arrow-quantity-box .quantity-number').forEach(function(qtyNumber){
          let pack = subscriptionOptions.pack;
          if (subscriptionOptions.template == 'pod') {
            if (subscriptionOptions.unit_step == 12) {
              if (pack != 1) {
                pack = (pack - 1) * 2;
              }
            }
          }
          if (subscriptionOptions.product_name == 'Limited Release: Dur Feres. Ethiopia' || subscriptionOptions.product_name == 'Limited Release: Todos Santos. Guatemala' || subscriptionOptions.product_name == 'Mother’s Day Special – 12 Oz' ) {
            qtyNumber.innerHTML = subscriptionOptions.pack
            subscriptionOptions.pack_onetime = subscriptionOptions.pack
          } else if (subscriptionOptions.currentProduct?.product.tags.includes('Product-Sell-Out')) {
            if (subscriptionOptions.template == 'pod') {
              qtyNumber.innerHTML = subscriptionOptions.pack * subscriptionOptions.unit_step
              subscriptionOptions.pack_onetime = subscriptionOptions.pack
            } else {
              qtyNumber.innerHTML = subscriptionOptions.pack
              subscriptionOptions.pack_onetime = subscriptionOptions.pack
            }
          } else {
            qtyNumber.innerHTML = pack*subscriptionOptions.unit_step;
          }
        });

        let isSubscribeWithOnePack = subscriptionOptions.pack == 1 && subscriptionOptions.currentRCType == 'autodeliver',
            currentVariant = isSubscribeWithOnePack ? subscriptionOptions.currentProduct?.product?.variants[0] : subscriptionOptions.currentVariant,
            currentProduct = isSubscribeWithOnePack ? subscriptionOptions.currentProduct.product : subscriptionOptions.currentProduct,
            pack = subscriptionOptions.currentRCType == 'autodeliver' ? subscriptionOptions.pack_autodeliver : subscriptionOptions.pack_onetime,
            compare_at_price = currentVariant.compare_at_price ? currentVariant.compare_at_price * pack : currentVariant.price * pack,
            regular_price = subscriptionOptions.volume_discounts_onetime?.length ? getCurrentDiscountedPrice(subscriptionOptions, pack, 'onetime') * pack : currentVariant.price * pack,
            subscribe_price = subscriptionOptions.hasSubscribe ? getCurrentDiscountedPrice(subscriptionOptions, pack, 'autodeliver') * pack : 0;

        subscriptionOptions.regular_price = regular_price;
        subscriptionOptions.subscribe_price = subscribe_price;

        document.body.querySelectorAll('.price-subscribe, .price-buynow').forEach(function (item) {
          const currentPrice = subscriptionOptions.currentRCType == 'autodeliver' ? subscribe_price : regular_price;

          item.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (currentPrice / 100));
        });

        if (subscriptionOptions.currentProduct.subscription) {
          let optionText = subscriptionOptions.option1;
          if (subscriptionOptions.template == 'pod' || optionText == 'Default Title') {
            optionText = '';
          }
          
          let labelText = nowPack + ' ';
          if (nowPack == 1) {
            labelText += subscriptionOptions.quantity_label[0];
          } else {
            labelText += subscriptionOptions.quantity_label[1];
          }
          labelText += ' Every ' + subscriptionOptions.shipping_interval_frequency + ' Weeks';

          const previewLabelElement = document.querySelector('.subscription-product-preview .label');
          const previewOptionElement = document.querySelector('.subscription-product-preview .option');

          if (previewLabelElement) previewLabelElement.innerHTML = labelText;
          if (previewOptionElement) previewOptionElement.innerHTML = optionText;
        }

        const currentPrice = subscriptionOptions.currentRCType == 'autodeliver' ? subscribe_price : regular_price;
        this.setKlaviyoItemPrices(currentPrice, compare_at_price)

        function setButtonPrices(volumeDiscounts) {
          if (!volumeDiscounts.length) {
            nowPricePerUnit = subscriptionOptions.currentVariant.price;
            quantityButtons.forEach(function(button) {
              const pricePerUnitElement = button.querySelector('.price-per-unit');
              let currentPrice = subscriptionOptions.currentVariant.price;

              if (!pricePerUnitElement) return;

              const isPricePerServing = pricePerUnitElement.hasAttribute('data-price-per-serving');
              if (isPricePerServing) {
                currentPrice = subscriptionOptions.currentVariant.price / subscriptionOptions.unit_step;
              };

              pricePerUnitElement.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (currentPrice / 100).toFixed(2));
              button.querySelector('.price-per-unit-label').innerHTML = ' each';
            });
            return;
          }

          volumeDiscounts.map(function(discount){
            const volumeQuantity = discount.split('--')[0];
            const volumePrice = Math.round(+discount.split('--')[1] * 100);
  
            quantityButtons.forEach(function(button){
              let pack = parseInt(button.getAttribute('data-pack'));
              const pricePerUnitElement = button.querySelector('.price-per-unit'); 

              if (window.dynamicPricing?.enabled) {
                const { currentRCType, unit } = subscriptionOptions;

                pack += window.dynamicPricing.totalQuantity?.[currentRCType]?.[unit] ?? 0;
              }
              
              if (pack >= volumeQuantity.replace('+', '') && !!pricePerUnitElement) {
                let price = 0;
                if (volumePrice) price = volumePrice || 0;
  
                if (subscriptionOptions.unit_step == 4 || subscriptionOptions.unit_step == 3) {
                  price = price/subscriptionOptions.unit_step;
                }

                const isPricePerServing = pricePerUnitElement.hasAttribute('data-price-per-serving');
                if (isPricePerServing) {
                  price = price / subscriptionOptions.unit_step;
                };

                pricePerUnitElement.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (price / 100).toFixed(2));
                button.querySelector('.price-per-unit-label').innerHTML = ' each';
              }
            });
            if (nowPack >= volumeQuantity.replace('+', '') && volumePrice) {
              nowPricePerUnit = volumePrice;
            }
          });
        }

        function getCurrentDiscountedPrice(product, currentQuantity, purchaseType = 'onetime') {
          const prices = purchaseType == 'autodeliver' ? product.volume_discounts_subs : product.volume_discounts_onetime;
          if (!prices) return 0;
      
          const maxVolumeQuantity = prices[prices.length - 1].split('--')[0].replace('+', '');
          
          const discountPerItem = prices.find((value) => {
            const quantity = value.split('--')[0].replace('+', '');
            return +quantity === currentQuantity || +quantity === +maxVolumeQuantity;
          })?.split('--')[1];
      
          return Math.round(discountPerItem * 100);
        }
      }

      setPrices() {
        const {
          pack,
          currentVariant,
          hasSubscribe,
          volume_discounts_onetime,
          currentRCType,
          option1,
          template,
          quantity_label,
          autodeliverPercent,
          onetimePercent,
        } = subscriptionOptions;
        
        let autodeliverPack = pack,
            onetimePack = pack;
        
        if (window.dynamicPricing?.enabled) {
          const { unit } = subscriptionOptions;

          autodeliverPack += window.dynamicPricing.totalQuantity?.['autodeliver']?.[unit] ?? pack;
          onetimePack += window.dynamicPricing.totalQuantity?.['onetime']?.[unit] ?? pack;
        }
      
        const formatMoney = value =>
          window.theme.moneyFormat.replace('{{amount}}', ((value / 100).toFixed(2)));
      
        const getDiscountedPrice = (product, qty, type = 'onetime') => {
          const prices =
            type === 'autodeliver'
              ? product.volume_discounts_subs
              : product.volume_discounts_onetime;
          if (!prices) return 0;
      
          const maxQty = +prices.at(-1).split('--')[0].replace('+', '');
          const discount = prices.find(value => {
            const quantity = +value.split('--')[0].replace('+', '');
            return quantity === qty || quantity === maxQty;
          })?.split('--')[1];
      
          return Math.round(discount * 100);
        };
      
        const getPriceByType = (isAutodeliver, total = true) =>
          isAutodeliver
            ? (total ? subscribePrice : subscribePrice / pack)
            : (total ? regularPrice : regularPrice / pack);
      
        const comparePrice = (currentVariant.compare_at_price || currentVariant.price) * pack;
        const regularPrice = volume_discounts_onetime?.length
          ? getDiscountedPrice(subscriptionOptions, onetimePack, 'onetime') * pack
          : currentVariant.price * pack;
        const subscribePrice = hasSubscribe
          ? getDiscountedPrice(subscriptionOptions, autodeliverPack, 'autodeliver') * pack
          : 0;
        const currentPrice = currentRCType === 'autodeliver' ? subscribePrice : regularPrice;
      
        subscriptionOptions.regular_price = regularPrice;
        subscriptionOptions.subscribe_price = subscribePrice;
      
        const getDiscountPercents = (discountsArray) => {
          const originalPrice = subscriptionOptions.currentVariant?.compare_at_price || subscriptionOptions.currentVariant?.price;
          let discountPercents = [];

          for (let i = 0; i < discountsArray.length; i++) {
            const discountString = discountsArray[i]?.split('--');
            const price = Math.round(+discountString[1] * 100);
            const discountPercent = Math.round((originalPrice - price) / originalPrice * 100);
  
            discountPercents.push(discountPercent);
          }

          return discountPercents;
        }

        const updateMainPrices = () => {
          document.querySelectorAll('.price-subscribe, .price-buynow').forEach(node => (node.innerHTML = formatMoney(currentPrice)));
        };
      
        const updateSubscriptionPreview = () => {
          if (!hasSubscribe) return;
          const optionText = (template === 'pod' || option1 === 'Default Title') ? '' : option1;
          const labelText = `${pack} ${pack === 1 ? quantity_label[0] : quantity_label[1]} Every ${subscriptionOptions.shipping_interval_frequency} Weeks`;
      
          const previewLabelElement = document.querySelector('.subscription-product-preview .label');
          const previewOptionElement = document.querySelector('.subscription-product-preview .option');

          if (previewLabelElement) previewLabelElement.innerHTML = labelText;
          if (previewOptionElement) previewOptionElement.innerHTML = optionText;
        };
      
        const updateOriginalPrices = () => {
          document.querySelectorAll('[data-price-original]')
            .forEach(node => {
              node.innerHTML = formatMoney(comparePrice);
              node.classList.toggle('hidden', comparePrice <= currentPrice);
            });
        };
      
        const updateCurrentPrices = () => {
          document.querySelectorAll('[data-price-current]')
            .forEach(node => {
              if (!node.hasAttribute('data-autodeliver') && !node.hasAttribute('data-onetime')) {
                const isAutodeliver = subscriptionOptions.currentRCType === 'autodeliver';
                const price = getPriceByType(isAutodeliver);
                node.innerHTML = formatMoney(price);
              } else {
                const price = getPriceByType(node.hasAttribute('data-autodeliver'));
                node.innerHTML = formatMoney(price);
              }
            });
        };
      
        const updatePerPackPrices = () => {
          document.querySelectorAll('[data-price-pack]')
            .forEach(node => {
              const price = getPriceByType(node.hasAttribute('data-autodeliver'), false);
              node.innerHTML = formatMoney(price);
            });
        };
      
        const updateDiscountLabels = () => {
          document.querySelectorAll('[data-discount-percent]').forEach(label => {
            const isAutodeliver = label.hasAttribute('data-autodeliver');
            const percents = isAutodeliver ? autodeliverPercent : onetimePercent;
            let currentPack = isAutodeliver ? autodeliverPack : onetimePack;
      
            let currentPercent = percents.at(-1);
            if (currentPack <= percents.length) currentPercent = percents[currentPack - 1];

            if (currentPercent === undefined || currentPercent === 'undefined') currentPercent = 0;
      
            label.closest('.option-selector__discount-badge')
              ?.classList.toggle('hidden', currentPercent <= 0);
            label.closest('.option-selector__heading')
              ?.querySelector('.option-selector__volume-prices')
              ?.classList.toggle('option-selector__volume-prices--no-discount', currentPercent <= 0);
      
            label.innerHTML = currentPercent;
      
            if (isAutodeliver) {
              document.querySelectorAll('.subscription-detail .discount')
                .forEach(discountLabel => {
                  discountLabel.innerHTML = `Save ${currentPercent}%`;
                });
            }
          });

           document.querySelectorAll('[data-discount-percent-original]').forEach(label => {
            const isAutodeliver = label.hasAttribute('data-autodeliver');
            const purchaseTypeKey = isAutodeliver ? 'autodeliver' : 'onetime';
            const { volume_discounts_original } = window.subscriptionOptions;
            let currentPack = isAutodeliver ? autodeliverPack : onetimePack;

            if (!volume_discounts_original || !volume_discounts_original[purchaseTypeKey]) return;

            const percents = getDiscountPercents(volume_discounts_original[purchaseTypeKey]);
            let currentPercent = percents.at(-1);
            if (currentPack <= percents.length) currentPercent = percents[currentPack - 1];

            if (currentPercent === undefined || currentPercent === 'undefined') currentPercent = 0;
            label.innerHTML = currentPercent;
          })
        };

        const updateSubscriptionBenefits = () => {
          const benefitsContainer = document.querySelector('.option-selector__content[data-purchase-type="autodeliver"]');
          const regularBenefits = benefitsContainer?.querySelector('.option-selector__benefits:not(.option-selector__benefits--quantity-1)');
          const singlePackBenefits = benefitsContainer?.querySelector('.option-selector__benefits--quantity-1');
          if (!regularBenefits || !singlePackBenefits) return;
          
          const {quantity: packQuantity} = singlePackBenefits.dataset;
          regularBenefits.classList.toggle('hidden', subscriptionOptions.pack <= +packQuantity);
          singlePackBenefits.classList.toggle('hidden', subscriptionOptions.pack > +packQuantity);
        }
      
        updateMainPrices();
        updateSubscriptionPreview();
        updateOriginalPrices();
        updateCurrentPrices();
        updatePerPackPrices();
        updateDiscountLabels();
        updateSubscriptionBenefits();
      
        this.setKlaviyoItemPrices(currentPrice, comparePrice);
      }
      
      setSellingPlan() {
        const currentProduct = window.subscriptionOptions?.currentProduct?.product || null;
        if (!currentProduct);

        const currentFrequencyNumber = window.subscriptionOptions.shipping_interval_frequency?.toString();
        const sellingPlanInputs = this.querySelectorAll('input[name="selling_plan"]');
        const sellingPlansGroups = currentProduct ? currentProduct?.selling_plan_groups : null;
              
        if (sellingPlansGroups && sellingPlansGroups[0]) {
          for (let i = 0; i < sellingPlansGroups[0].selling_plans.length; i++) {
            const sellingPlan = sellingPlansGroups[0].selling_plans[i];
  
            if (sellingPlan.name.split(' ').includes(currentFrequencyNumber)) {
              sellingPlanInputs.forEach(input => {
                input.value = sellingPlan.id;
              })
              break;
          }
          }
        }
      }
      
      setKlaviyoItemPrices(price, compareAtPrice) {
        if (typeof klaviyoItem != 'undefined') {
          klaviyoItem.CompareAtPrice = window.theme.moneyFormat.replace('{{amount}}', (compareAtPrice / 100));
          klaviyoItem.Price = window.theme.moneyFormat.replace('{{amount}}', (price / 100));
        }
      }

      setGiftsAvailability() {
        this.productGifts.forEach(gift => {
          const { requiredQuantityOnce, requiredQuantitySubscription } = gift.dataset;
          const currentPack = subscriptionOptions.pack;
          const isAutodeliver = subscriptionOptions.currentRCType === 'autodeliver';
          const requiredQuantity = isAutodeliver ? parseInt(requiredQuantitySubscription) : parseInt(requiredQuantityOnce);
          const quantityTextBlock = gift.querySelector('[data-required-quantity-block]');
          
          if (quantityTextBlock) quantityTextBlock.innerHTML = requiredQuantity;
          gift.classList.toggle('product-gift--locked', currentPack < requiredQuantity);
          gift.querySelectorAll('input').forEach(input => {
            input.disabled = currentPack < requiredQuantity;
            if (input.name.includes('parent_id') || input.name.includes('_landing_gift')) input.value = subscriptionOptions.currentVariantID;
          });
        })
      }

      getSubscribeVariants() {
        let currentProduct = subscriptionOptions.currentProduct?.product || null;
        let currentVariant = null;
        let hasSubscribe = subscriptionOptions.hasSubscribe || 0;
        
        if (currentProduct != null) {
          for (let i in currentProduct.variants) {
            if (
              (this.areVariantOptionsEquivalent(currentProduct.variants[i].option1, subscriptionOptions.option1)) &&
              (currentProduct.variants[i].option2 == null || currentProduct.variants[i].option2 == subscriptionOptions.option2) &&
              (currentProduct.variants[i].option3 == null || currentProduct.variants[i].option3 == subscriptionOptions.option3)
            ) {
              currentVariant = currentProduct.variants[i];
              subscriptionOptions.currentVariantID = currentVariant.id;
            }
          }

          if (currentVariant == null && currentProduct.variants?.length) {
            currentVariant = currentProduct.variants.find(v => v.available) || currentProduct.variants[0];
            subscriptionOptions.currentVariantID = currentVariant.id;
            subscriptionOptions.option1 = currentVariant.option1;
          }
        }
        
        let autoDiscounts = [], onetimeDiscounts = [];
        const subsDiscountMetafield = subscriptionOptions.volume_discounts_subs,
              onetimeDiscountsMetafield = subscriptionOptions.volume_discounts_onetime,
              originalPrice = subscriptionOptions.currentVariant?.compare_at_price || subscriptionOptions.currentVariant?.price;

        getDiscountPercents(onetimeDiscountsMetafield, 'onetime')
        if (hasSubscribe) getDiscountPercents(subsDiscountMetafield, 'subscription')

        subscriptionOptions.autodeliverPercent = autoDiscounts;
        subscriptionOptions.onetimePercent = onetimeDiscounts;
        subscriptionOptions.currentProduct.product = currentProduct;
        subscriptionOptions.currentVariant = currentVariant;

        const previewOptionText = subscriptionOptions.template === 'pod' || subscriptionOptions.option1 === 'Default Title'
          ? '' : subscriptionOptions.option1 || '';
        (this.closest('.product__section') || this).querySelectorAll('.subproduct-preview-item .option').forEach(option => {
          option.textContent = previewOptionText;
        });
      
        /* Set new selling plan ID */
        if (!document.querySelector('html').getAttribute('page.subscription-v2')) {
          setTimeout(() => {
            this.setSellingPlan();
          }, 0)
        }

        this.querySelectorAll('input[name="id"]').forEach(input => {
          input.value = subscriptionOptions.currentVariantID
        })

        this.querySelectorAll('input[name="quantity"]').forEach(input => {
          input.value = subscriptionOptions.pack;
        })

        function getDiscountPercents(discountsArray, purchaseType) {
          for (let i = 0; i < discountsArray.length; i++) {
            const discountString = discountsArray[i]?.split('--');
            const price = Math.round(+discountString[1] * 100);
            const discountPercent = Math.round((originalPrice - price) / originalPrice * 100);
  
            purchaseType == 'subscription' ? autoDiscounts.push(discountPercent) : onetimeDiscounts.push(discountPercent)
          }
        }
      }
    }
  );
}

if (!customElements.get('subscription-product-popup')) {
  customElements.define(
    'subscription-product-popup',
    class SubscriptionProductPopup extends HTMLElement {
      constructor() {
        super();
        this.closeButton = this.querySelector('#subscription-close-btn')
        this.addToCartButton = this.querySelector('.subscription-popup__button');
      }

      connectedCallback() {
        this.attachEventListeners();
      }

      attachEventListeners() {
        this.closeButton?.addEventListener('click', this.closePopup.bind(this));
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          event.stopPropagation();
          this.closePopup();
        });
        this.addToCartButton?.addEventListener('click', this.handleATCButtonClick)
      }

      openPopup(trigger) {
        this.trigger = trigger;
        document.body.classList.add('subscription-open');
        trapFocus(this, this.closeButton || this);
      }

      closePopup() {
        document.body.classList.remove('subscription-open');
        removeTrapFocus(this.trigger);
      }

      handleATCButtonClick() {
        document.querySelector('.product-form__buttons button[name="add"]')?.click();
      }
    }
  )
}

if (!customElements.get('quick-buy-banner')) {
  customElements.define(
    'quick-buy-banner',
    class QuickBuyBanner extends HTMLElement {
      constructor() {
        super();

        this.autodeliverLabel = this.querySelector('.option-selector-autodeliver label');
        this.autodeliverInput = this.querySelector('.option-selector-autodeliver input[type="radio"]');
      }

      connectedCallback() {
        window.addEventListener('scroll', this.toggleSubscriptionBar);
      }

      setAvailability(isUnavailable) {
        this.querySelectorAll('.Button').forEach(button => {
          button.classList.toggle('Button--sold-out', isUnavailable);
          button.setAttribute('aria-disabled', String(isUnavailable));
          button.disabled = isUnavailable;

          const label = button.querySelector('.button__text');
          if (!label) return;
          if (!label.dataset.availableText && !isUnavailable) label.dataset.availableText = label.textContent;
          label.textContent = isUnavailable ? window.variantStrings.soldOut : label.dataset.availableText;
        });
      }

      toggleSubscriptionBar() {
        let subscriptionSection = document.querySelector('.product__section');
        if (subscriptionSection) {
          var windowOffset = window.pageYOffset;
          var sectionHeight = subscriptionSection.clientHeight;
          var sectionOffset = subscriptionSection.offsetTop;
          sectionOffset = sectionOffset + sectionHeight;
          
          if (windowOffset >= sectionOffset) {
            document.body.classList.add('subscription-bar-open');
          } else {
            document.body.classList.remove('subscription-bar-open');
          }
        }
      }

    }
  )
}
 